export const RightColumnMode = Object.freeze({
    SLIDESHOW: "SLIDESHOW",
    WELCOME: "WELCOME",
});
